import { render, staticRenderFns } from "./VFormWidget.vue?vue&type=template&id=a09ae746&scoped=true"
import script from "./VFormWidget.vue?vue&type=script&lang=js"
export * from "./VFormWidget.vue?vue&type=script&lang=js"
import style0 from "./VFormWidget.vue?vue&type=style&index=0&id=a09ae746&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09ae746",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a09ae746')) {
      api.createRecord('a09ae746', component.options)
    } else {
      api.reload('a09ae746', component.options)
    }
    module.hot.accept("./VFormWidget.vue?vue&type=template&id=a09ae746&scoped=true", function () {
      api.rerender('a09ae746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/components/VFormWidget.vue"
export default component.exports